import { ZodSchema } from 'zod';

export interface PaginatedRequest {
  page: number;
  limit: number;
}

export function toValidator<T>(schema: ZodSchema) {
  return (values: T) => {
    const result = schema.safeParse(values);
    if (result.success) return {};
    return result.error.formErrors.fieldErrors;
  };
}

export interface QueryParams {
  page: number;
  limit: number;
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  search: string;
}
